
import Browser, {Browser as BrowserApi} from "./browser";
import { ICommandResponse, IListenerCollection, IListener, IListenerCallback, IPluginInfo, ICommandArgs } from "./types";

export default class BBPlugin
{
    public api: BrowserApi;
    public cid: string;
    public name: string;
    public info: IPluginInfo;
    protected listeners: IListenerCollection;

    constructor(client: BrowserApi, cid: string, name: string, info?: IPluginInfo)
    {
        this.api = client;
        this.cid = cid || null;
        this.name = name;
        this.info = info || {} as IPluginInfo;
        this.listeners = {};
    }

    public isAvailable(): boolean { return this.cid != null; }

    public getInfo(): IPluginInfo
    {
        let res = this.api.cmd('plugin-info', {name: this.name});
        if (res && res.success) {
            this.info = res.results;
        }
        return this.info;
    }

    public call(method: string, args?: ICommandArgs): ICommandResponse
    {
        if (!this.isAvailable)
        {
            throw new Error(`Unable to call plugin ${this.name}`);
        }

        return this.api.cmd('run', {plugin: this.name, cid: this.cid, cmd: method, args: args});
    }

    public unplug(): void
    {
        this.api.cmd('unplug', {plugin: this.name, cid: this.cid});
        this.listeners = {
            '*': []
        };
        delete this.api.plugins[this.cid];
        console.debug('Unplug', this);
    }

    public on(event: string, callback: IListenerCallback, context?): void
    {
        if (!this.listeners.hasOwnProperty(event)) 
        {
            this.listeners[event] = [];
        }
        this.listeners[event].push({cb: callback, context: (context || this) });
    }

    public off(event: string, callback?: IListenerCallback): void
    {
        if (this.listeners.hasOwnProperty(event)) 
        {
            if (!callback) 
            {
                this.listeners[event].length = 0;
            } else 
            {
                var index = -1;

                this.listeners[event].some((listener, idx) =>
                {
                    if (listener.cb === callback) 
                    {
                        index = idx;
                        return true;
                    }
                });
                if (index >= 0) 
                {
                    this.listeners[event].splice(index, 1);
                }
            }
        }
    }

    public trigger(event: string, args: ICommandArgs): void
    {
        if (this.listeners.hasOwnProperty(event)) {
            this.listeners[event].forEach((listener) =>
            {
                listener.cb.apply(listener.context, args);
            });
        }
        if (event !== '*') {
            this.trigger('*', args);
        }
    }
}